// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f768d6b","455":"de42dc35","977":"51a1344e"}[chunkId] + ".chunk.js";
};